import React, { FC } from 'react';
import { LoadingButton } from 'components/loadingbutton/LoadingButton';
import { useTranslation } from 'react-i18next';
import styles from '../default/styles.module.scss';
import { useFeatures } from 'useFeatures';

interface PaymentButtonProps {
  isLoading: boolean;
}

export const PayPalElement: FC<
  PaymentButtonProps & { onContinue: () => void }
> = ({ isLoading, onContinue }) => {
  const { t } = useTranslation();

  const { isLivenOnboardingFlow } = useFeatures();

  return (
    <div>
      <ul
        className={`${styles.checkList} ${
          isLivenOnboardingFlow ? styles.liven : ''
        }`}
      >
        <li>
          <span>Fast checkout</span>
        </li>
        <li>
          <span>Protects your financial data</span>
        </li>
        <li>
          <span>Secure transaction</span>
        </li>
      </ul>
      <LoadingButton
        isLoading={isLoading}
        label={isLivenOnboardingFlow ? 'Continue' : t('continueSecurely')}
        onClick={onContinue}
        className={`${styles.paypalBtn} ${
          isLivenOnboardingFlow ? styles.liven : ''
        }`}
      />
    </div>
  );
};
